import React, { useEffect } from "react";
// import JobHireHero from "../components/jobsHirePage/JobHireHero";
import DaasService from "../components/daasServicePage/daasService";
 
import Navbar from "../components/homepage/Navbar";
import { Header, Footer } from "../shared";
// import Recruiters from "../components/jobsHirePage/Recruiters";

const DaasServicePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <DaasService />
      {/* <JobHireHero /> */}
      {/* <Recruiters /> */}
      <Footer />
    </div>
  );
};

export default DaasServicePage;
